import { useEffect, useRef, useState } from "react";
import OrderDetailViewContainer from "./OrderDetailViewMainContainer"
import { useSelector } from "react-redux";
import { CONSTANTS } from "client/utils/constants";

const OrderDetailViewContainer_Container = (props: any) => {
  const { isBulkOrder = false } = props
    const wrapperRef = useRef<any>(null);
    const [selectedOrderDetailKey, setSelectedOrderDetailKey] = useState("requisition");
    const [showOrderDetailBreadcrumb, setShowOrderDetailBreadcrumb] = useState(false);
    const [tabSwitchClicked, setTabSwitchClicked] = useState(false)
    const [tab, setTab] = useState('')
    const handleOrderLinkClick = (item?: any) => {
      if (item) {
        if(item?.props?.itemKey === CONSTANTS?.KEY_FLEET_PROCESSING){
          setSelectedOrderDetailKey(item.props?.itemKey);
          setTab(item.props?.itemKey)
          setShowOrderDetailBreadcrumb(true)
          setTabSwitchClicked(false)
        } else {
          const orderDetailBreadCrumb = item.props.itemKey !== 'requisition'
          setShowOrderDetailBreadcrumb(orderDetailBreadCrumb)
          setTab(item.props?.itemKey)
          setTabSwitchClicked(true)
        }
      }
    };
    const activeOrderDetailNavigation = useSelector((state: any) => state.nav.nav)

    useEffect(() => {
        document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
    }, [activeOrderDetailNavigation]);
    
    return(
        <OrderDetailViewContainer 
        wrapperRef={wrapperRef} 
        selectedKey={selectedOrderDetailKey} 
        setSelectedKey={setSelectedOrderDetailKey}
        showFleetBreadcrumb={showOrderDetailBreadcrumb} 
        handleLinkClick={handleOrderLinkClick}
        tabSwitchClicked={tabSwitchClicked}
        setTabSwitchClicked={setTabSwitchClicked}
        setShowFleetBreadcrumb={setShowOrderDetailBreadcrumb}
        isBulkOrder={isBulkOrder}
        tab={tab}
        />
    )
}

export default OrderDetailViewContainer_Container